const HeroFilter = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const heroEl = document.querySelector('.hero-wrapper');
    const filterButtonsWrapper = document.querySelector('.button-wrapper.filters');

    if (heroEl && filterButtonsWrapper) {
      heroEl.classList.add('whats-on');

      const heroButtons = heroEl.querySelectorAll('.button-wrapper .btn-primary');
      const tileGridWrapper = document.querySelector('.tile-grid-wrapper');
      const tileGrid = document.querySelector('.tile-grid');

      tileGridWrapper.style.transition = 'height 0.4s ease';
      tileGridWrapper.style.overflow = 'hidden';
      tileGridWrapper.style.minHeight = "896px"; 

      heroButtons.forEach((button) => {
        tileGridWrapper.setAttribute('data-filter', 'All');

        button.addEventListener('click', (event) => {
          event.preventDefault();

          heroButtons.forEach((btn) => btn.classList.remove('active'));
          button.classList.add('active');

          const targetId = button.getAttribute('data-filter');
          tileGridWrapper.setAttribute('data-filter', targetId);

          const gridTiles = tileGridWrapper.querySelectorAll('.grid-tile');
          tileGrid.classList.remove('is-visible');
          gridTiles.forEach((tile) => tile.classList.add('hidden'));

          //First RAF completes DOM changes made
          requestAnimationFrame(() => {
            //Second RAF performs layout-dependent calculations (measure height etc.)
            requestAnimationFrame(() => {
              gridTiles.forEach((tile) => {
                const tileFilter = tile.getAttribute('data-filter');
                const shouldShow =
                  targetId === 'All' ||
                  tileFilter === targetId ||
                  (targetId === 'Coming Soon' && tileFilter === 'Tickets On Sale');

                if (shouldShow) {
                  tile.classList.remove('hidden');
                }
              });

              void tileGrid.offsetWidth;
              tileGrid.classList.add('is-visible');

              const currentHeight = tileGridWrapper.offsetHeight;
              tileGridWrapper.style.height = currentHeight + 'px'; 

              tileGridWrapper.style.minHeight = '';
              tileGridWrapper.style.height = 'auto';
              const targetHeight = tileGridWrapper.scrollHeight + 'px';

              tileGridWrapper.style.height = currentHeight + 'px'; 
              requestAnimationFrame(() => {
                tileGridWrapper.style.height = targetHeight;

                const handleTransitionEnd = () => {
                  tileGridWrapper.style.height = 'auto'; 
                  tileGridWrapper.removeEventListener('transitionend', handleTransitionEnd);
                };

                tileGridWrapper.addEventListener('transitionend', handleTransitionEnd);
              });
            });
          });
        });
      });
    }
  });
};

export default HeroFilter;